import { cdnURL } from 'utils/helpers';

export const IconStep1 = [
  {
    filename: 'icon_step_1.png',
    image_url: cdnURL('progress-campaign/icon_step_1.png')
  }
];

export const IconSuccess = [
  {
    filename: 'icon_step_success.png',
    image_url: cdnURL('progress-campaign/icon_step_success_v2.png')
  }
];

export const IconStep = [
  {
    filename: 'icon_step.png',
    image_url: cdnURL('task_icon.png')
  }
];
